import Swiper, { Navigation, Pagination } from 'swiper/core'

Swiper.use([Navigation, Pagination])

// 施設リスト内カセット（ランキング／施設タイプ別／特集）をPCでSwiperスライド化する。
// data-cassette-carousel を持つ要素だけを対象にするため、対象要素を出さないSP（横スクロール）では何もしない。
function initCassetteCarousels () {
  document.querySelectorAll('[data-cassette-carousel]').forEach((root) => {
    const container = root.querySelector('[data-cassette-carousel-swiper]')
    if (!container || container.dataset.swiperInitialized === 'true') return

    // 1つの初期化失敗が残りのカルーセルを巻き込まないよう個別に握りつぶす
    try {
      container.dataset.swiperInitialized = 'true'
      // eslint-disable-next-line no-new
      new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: Number(root.dataset.cassetteCarouselGap || 16),
        navigation: {
          prevEl: root.querySelector('[data-cassette-carousel-prev]'),
          nextEl: root.querySelector('[data-cassette-carousel-next]'),
        },
        pagination: {
          el: root.querySelector('[data-cassette-carousel-pagination]'),
          clickable: true,
          bulletActiveClass: root.dataset.cassetteCarouselActiveClass,
        },
      })
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('cassette carousel の初期化に失敗しました', e)
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCassetteCarousels)
} else {
  initCassetteCarousels()
}
